import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import CallbackPage from '../containers/pages/CallbackPage';
import LogoutPage from '../containers/pages/LogoutPage';
import LogoutCallbackPage from '../containers/pages/LogoutCallbackPage';
import UnauthorizedPage from '../containers/pages/UnauthorizedPage';
import SelecaoEmpresaPage from '../containers/pages/SelecaoEmpresaPage';
import HomePage from '../containers/pages/HomePage';
import ListagemDetalhamentoFaturamentoPage from '../containers/pages/ListagemDetalhamentoFaturamentoPage';
import ListagemPedidoPage from '../containers/pages/ListagemPedidoPage';
import DetalhamentoPedidoPage from '../containers/pages/DetalhamentoPedidoPage';
import ListagemServicoPage from '../containers/pages/ListagemServicoPage';
import CarroConectadoPage from '../containers/pages/CarroConectadoPage';
import ListagemContatoPage from '../containers/pages/ListagemContatoPage';
import NotFoundPage from '../containers/pages/NotFoundPage';
import { MenuEnum } from '../enums';

function Routes() {
    const ud = JSON.parse(localStorage.getItem('user_data'));

    return (
        <Switch>
            <Route exact
                path="/signin-callback"
                component={CallbackPage} />

            <Route exact
                path="/signout"
                component={LogoutPage} />

            <Route exact
                path="/signout-callback"
                component={LogoutCallbackPage} />

            <Route exact
                path="/403"
                component={UnauthorizedPage} />

            <Route exact
                path="/selecao-empresa"
                component={SelecaoEmpresaPage} />

            <PrivateRoute exact
                path={MenuEnum.properties[MenuEnum.HOME].path}
                component={HomePage} />

            <PrivateRoute exact
                path={MenuEnum.properties[MenuEnum.FATURAS].path}
                component={ListagemDetalhamentoFaturamentoPage} />

            <PrivateRoute exact
                path={MenuEnum.properties[MenuEnum.MEUS_CARROS].path}
                component={ListagemPedidoPage} />

            <PrivateRoute exact
                path={`${MenuEnum.properties[MenuEnum.MEUS_CARROS].path}/:contrato/:pedido/:item/:sequencia`}
                component={DetalhamentoPedidoPage} />

            <PrivateRoute exact
                path={`${MenuEnum.properties[MenuEnum.SERVICOS].path}/:placa`}
                component={ListagemServicoPage} />

            {
                ud !== null &&
                ud.acessoCarroConectado === true &&
                <PrivateRoute exact
                    path={MenuEnum.properties[MenuEnum.CARRO_CONECTADO].path}
                    component={CarroConectadoPage} />
            }

            <PrivateRoute exact
                path={MenuEnum.properties[MenuEnum.CONTATOS].path}
                component={ListagemContatoPage} />

            <Route component={NotFoundPage} />
        </Switch>);
}

export default Routes;